module.exports = __webpack_public_path__ + "static/media/left_tree@3x.b91b4ced.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/subject/left_tree@3x.png
// module id = 784
// module chunks = 1